import * as React from "react";
import { Grid, GridItem, Text, VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "components";
import { OtherEnum } from "requests";
import { COLUMN_1, COLUMN_2, COLUMN_3 } from "./duck";

interface ColumnProps {
  options: { value: OtherEnum; label: string }[];
}

const Column: React.FC<ColumnProps> = ({ options }) => {
  const { setValue, watch } = useFormContext<any>();
  const otherValue: OtherEnum[] = watch("other");
  return (
    <GridItem as={VStack} spacing="4px" alignItems="flex-start" flex="1">
      {options.map(opt => (
        <Checkbox
          isChecked={otherValue.includes(opt.value)}
          onChange={event => {
            const { checked } = event.target;
            if (checked) {
              setValue("other", [...otherValue, opt.value]);
            } else {
              setValue(
                "other",
                otherValue.filter(id => id !== opt.value)
              );
            }
          }}
          label={opt.label}
          value={opt.value}
          key={opt.value}
        />
      ))}
    </GridItem>
  );
};

const Other: React.FC = () => (
  <VStack display="inline-flex">
    <Text alignSelf="flex-start" color="black">
      Other
    </Text>
    <Grid gridTemplateColumns="repeat(3, 1fr)" gridGap="60px">
      <Column options={COLUMN_1} />
      <Column options={COLUMN_2} />
      <Column options={COLUMN_3} />
    </Grid>
  </VStack>
);

export default Other;
